import { Box, Text } from "theme-ui";

import * as styles from "./BladeGuide.styles";

export default function BladeGuide({ blades = [] }) {
  return (
    <Box sx={styles.bladeGuide}>
      <Box sx={styles.bladesContainer}>
        {blades.map(({ title, description, image }) => (
          <Box key={title} sx={styles.blade}>
            <Box
              key={image.url}
              as="div"
              sx={styles.image}
              style={{ backgroundImage: `url(${image.url})` }}
            />

            <Text as="div" variant="h4">
              {title}
            </Text>

            <Text
              as="div"
              variant="copy3Light"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
